import { render, staticRenderFns } from "./PredictedVariableIncomeInsight.vue?vue&type=template&id=672c7900&scoped=true"
import script from "./PredictedVariableIncomeInsight.vue?vue&type=script&lang=js"
export * from "./PredictedVariableIncomeInsight.vue?vue&type=script&lang=js"
import style0 from "./PredictedVariableIncomeInsight.vue?vue&type=style&index=0&id=672c7900&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672c7900",
  null
  
)

export default component.exports